/**
 * Assert payment response DTO
 */
export class AssertPaymentResponseDto {
	transactionId!: string;
	status!: string;
	liability?: string;
}
